import { useDialog } from '@app/core/hooks';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';
import { AutoOpenFragmentField } from './fields/AutoOpenFragmentField';
import { PlayOnCursorSetField } from './fields/PlayOnCursorSetField';
import { ScreenModeField } from './fields/ScreenModeField';
import { KeepSelectionField } from './KeepSelectionField';

export function ConfigView() {
  const { open, onOpen, onClose } = useDialog();
  const { formatMessage } = useIntl();

  const settings = useStreamSettingsStore((state) => state);
  const updateSettings = useStreamSettingsStore((state) => state.updateSettings);

  return (
    <div className="d-inline-block">
      <Tooltip
        title={formatMessage({
          id: 'logger.streamScreen.screenSettings.tooltip',
          defaultMessage: 'Ajustes de pantalla',
        })}
      >
        <IconButton onClick={onOpen} size="small">
          <DisplaySettingsIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Box display="flex" alignItems="center" gap={1}>
            <DisplaySettingsIcon />
            <FormattedMessage
              id="logger.streamScreen.screenSettings.btn"
              defaultMessage="Ajustes"
            />
          </Box>
        </DialogTitle>
        <FormContainer
          defaultValues={{
            mode: settings.mode,
            autoOpenFragmentMode: settings.autoOpenFragmentMode,
            playOnCursorSet: settings.playOnCursorSet,
            keepSelectionOnRangeChange: settings.keepSelectionOnRangeChange,
          }}
          onSuccess={(data) => {
            updateSettings({
              mode: data.mode,
              autoOpenFragmentMode: data.autoOpenFragmentMode,
              playOnCursorSet: data.playOnCursorSet,
              keepSelectionOnRangeChange: data.keepSelectionOnRangeChange,
            });
            onClose();
          }}
        >
          <DialogContent>
            <Grid container spacing={2} alignItems="center">
              <ScreenModeField />
              <AutoOpenFragmentField />
              <PlayOnCursorSetField />
              <KeepSelectionField />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={onClose}>
                <FormattedMessage id="common.actions.cancel" defaultMessage="Cancelar" />
              </Button>
              <Button type="submit" variant="contained" color="primary">
                <FormattedMessage id="common.actions.save" defaultMessage="Guardar" />
              </Button>
            </Stack>
          </DialogActions>
        </FormContainer>
      </Dialog>
    </div>
  );
}
